// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

// Styling
import './documentation-data.scss';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import DocumentService from '../../../redux/services/document';

// Utils
import { convertBase64ToArrayBuffer, downloadFile } from '../../../common/utils/download-utils';
import { isMobileOnly } from 'react-device-detect';

class DocumentationDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
    }

    downloadDocument(documentRef) {
        DocumentService.downloadDocument(documentRef)
          .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
          });
    }

    documentDownloadBodyTemplate(rowData) {
        return <div className='t-align-center'>
                    <Button icon="pi pi-download" onClick={() => this.downloadDocument(rowData.documentRef)} />
                </div>;
    }

    render() {
        return (
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                  <div className='col-1'></div>
                  <div className="col-10">
                      <div className="card mgt-20">
                        {
                          this.props.processDocs != null ? 
                              <DataTable value={this.props.processDocs} paginator className="p-datatable-gridlines" showGridlines rows={10} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("profile.messages.no-documents")}>
                                  <Column field="name" header={this.props.t("profile.areas.documents.name-header")} />
                                  <Column field="documentRef" header={this.props.t("profile.areas.documents.download-header")} body={(data) => this.documentDownloadBodyTemplate(data)} style={{ maxWidth: '30px' }}  />
                              </DataTable>
                          : null
                        }
                      </div>
                  </div>
                  <div className='col-1'></div>
                  <Toast position='bottom-left' ref={this._toast} />
              </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        processDocs: state.profile.processDocs
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(DocumentationDataComponent));